// extracted by mini-css-extract-plugin
export var columnItem = "_bd-3";
export var columnItemDraggable = "_bd-4";
export var dragHandle = "_bd-0";
export var dragHandleHovered = "_bd-1";
export var dropdown = "_bd-5";
export var dropdownContent = "_bd-7";
export var dropdownInner = "_bd-6";
export var filterDropdownHeader = "_bd-8";
export var icon = "_bd-2";
export var sectionDivider = "_bd-9";